import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Log'
const DB_VERSION = 1
const STORE_NAME = 'Logs'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: 'id' }
])

const initDbErrors = () => {
    return dbInstance.init()
}

const agregar = async (data) => {
    return dbInstance.add(STORE_NAME, data)
}

const obtener = async (clave) => {
    return dbInstance.get(STORE_NAME, clave)
}

const actualizar = async (data) => {
    return dbInstance.put(STORE_NAME, data)
}

const eliminar = async (clave) => {
    return dbInstance.delete(STORE_NAME, clave)
}

const removerTodo = async (databaseName) => {
    return dbInstance.deleteDatabase()
}

const consultar = async () => {
    return dbInstance.getAll(STORE_NAME)
}

export default {
    initDbErrors,
    agregar,
    obtener,
    actualizar,
    eliminar,
    removerTodo,
    consultar
}
